module.exports = __webpack_public_path__ + "static/media/chess3.3146bd58.png";